import _ from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
import { getPartnerProductDetailsApi, getAllPartnerProductApi, getFilterPartnerProductApi } from './partnerProductApi';

// ----------------------------------------------------------------------

const initialState = {
  partnerProductList: [],
  getFilterPartnerProduct: [],
  isPartnerProductLoading: false,
  selectedPartnerProduct: {}
};

const slice = createSlice({
  name: 'partnerproduct',
  initialState,
  reducers: {},
  extraReducers: {
    [getAllPartnerProductApi.pending]: (state) => {
      state.isPartnerProductLoading = true;
    },
    [getAllPartnerProductApi.fulfilled]: (state, action) => {
      state.partnerProductList = action.payload;
      state.isPartnerProductLoading = false;
    },
    [getAllPartnerProductApi.rejected]: (state) => {
      state.isPartnerProductLoading = false;
    },
    [getPartnerProductDetailsApi.fulfilled]: (state, action) => {
      state.selectedPartnerProduct = action.payload;
    },
    [getFilterPartnerProductApi.fulfilled]: (state, action) => {
      state.getFilterPartnerProduct = action.payload;
    }
  }
});
export const partnerProductAction = slice.actions;

export default slice.reducer;
